import { render } from "./PlayBox.vue?vue&type=template&id=330432ba"
import script from "./PlayBox.vue?vue&type=script&lang=js"
export * from "./PlayBox.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__